var map = {
	"./amex.png": 1030,
	"./diners.png": 1031,
	"./discover.png": 1032,
	"./jcb.png": 1033,
	"./maestro.png": 1262,
	"./mastercard.png": 1034,
	"./stripe.png": 1035,
	"./union.png": 1036,
	"./unknown.png": 712,
	"./visa.png": 1037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1261;